import { isAfter, isSameDay } from 'date-fns';

export const isSameDayOrBefore = (time: Date, timeToCheck: Date): boolean =>
  isSameDay(time, timeToCheck) || !isAfter(time, timeToCheck);
